(ns basic-components.dropdown-button
  (:require
   [ui.util :as uu]
   [frontend.bootstrap.components :as rbs]
   [reagent.core :as r]
   [frontend.utils :as fu]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]))

(defn view
  [{:keys [dropdown-actions force-dropdown-visible?
           button class-name on-toggle!]}]
  (let []
    (fn [{:keys [dropdown-actions force-dropdown-visible?
                 button class-name on-toggle!]}]
      (when-not (empty? dropdown-actions)
        [dropdown-menu/view
         {:trigger [dropdown-menu/button-trigger-open
                    [:i.fas.fa-ellipsis-v]]
          :items   (->> dropdown-actions
                        (map-indexed
                         (fn [idx action]
                           (let [{:keys [label icon ord tooltip-text dropdown-color divider divider?
                                         on-select disabled? toggle-item? checked? on-checked-change]}
                                 action]
                             {:label          label
                              :icon-class     (uu/cm "fal" icon)
                              :separator?     divider?
                              :disabled?      (boolean disabled?)
                              :section-label? (true? divider)
                              :on-click       on-select})))
                        (doall))}]))))
